import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Form, Select, Button, message } from 'antd'
import Page from '../../../components/Page'
import { createBooklet } from '../../../redux/actions/booklets'
import { getProducts } from '../../../api/products'
import { getCoupons } from '../../../api/coupons'

const { Option } = Select

const BookletsAdd = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [form] = Form.useForm()

  const [products, setProducts] = useState([])
  const [loadingProducts, setLoadingProducts] = useState(false)
  const [loadingCoupons, setLoadingCoupons] = useState(false)

  useEffect(() => {
    const loadProducts = async () => {
      try {
        setLoadingProducts(true)
        const data = await getProducts()
        setProducts(data?.result || data || [])
      } catch {
        message.error('Failed to load products')
      } finally {
        setLoadingProducts(false)
      }
    }

    loadProducts()
  }, [])

  const onFinish = (values) => {
    const payload = {
      purchaseProductId: values.purchaseProductId,
      redeemProductId: values.redeemProductId,
    }

    dispatch(
      createBooklet({
        data: payload,
        navigate,
      }),
    )
  }

  return (
    <Page pageTitle={t('booklets.new', 'New booklet')} withCancelBtn={true}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label={t('booklets.field.purchaseProduct', 'Purchase product')}
          name="purchaseProductId"
          rules={[{ required: true, message: t('fields.required') }]}
        >
          <Select
            loading={loadingProducts}
            placeholder={t('fields.select product')}
            showSearch
            optionFilterProp="children"
          >
            {products?.map((product) => (
              <Option key={product.id} value={product.id}>
                {`${product.title} - ${product.sapId}`}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={t('booklets.field.redeemProduct', 'Redeem product')}
          name="redeemProductId"
          rules={[{ required: true, message: t('fields.required') }]}
        >
          <Select
            loading={loadingProducts}
            placeholder={t('fields.select product')}
            showSearch
            optionFilterProp="children"
          >
            {products?.map((product) => (
              <Option key={product.id} value={product.id}>
                {product.title}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loadingProducts}>
            {t('app.save')}
          </Button>
        </Form.Item>
      </Form>
    </Page>
  )
}

export default BookletsAdd
